import { Button } from '@/components/ui/button'
import { useProjectSlackChannels } from '@/frontend/features/Fde/useProjectSlackChannels'

interface Props {
  projectId: string
  value: string
  current: { id: string; name: string } | null
  onChange: (value: string) => void
  copy: Record<string, string>
}

export default function ProjectSlackChannelPicker({ projectId, value, current, onChange, copy }: Props) {
  const { channels, loading, failed, nextCursor, refresh, more } = useProjectSlackChannels(projectId, true)
  const options = current && !channels.some(row => row.id === current.id) ? [current, ...channels] : channels
  return <div className="mt-3 space-y-2">
    <label className="block text-xs font-medium" htmlFor={`slack-channel-${projectId}`}>{copy.select_channel}</label>
    <div className="flex flex-wrap items-center gap-2">
      <select id={`slack-channel-${projectId}`} value={value} onChange={event => onChange(event.target.value)} className="h-9 w-full max-w-sm rounded-md border border-input bg-background px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <option value="">{copy.channel_placeholder}</option>
        {options.map(channel => <option key={channel.id} value={channel.id}>#{channel.name}</option>)}
      </select>
      <Button variant="ghost" size="sm" disabled={loading} onClick={refresh}>{copy.refresh_channels}</Button>
      {nextCursor && <Button variant="ghost" size="sm" disabled={loading} onClick={more}>{copy.load_more}</Button>}
    </div>
    <p className="text-xs text-muted-foreground">{copy.channel_hint}</p>
    <p className="text-xs text-muted-foreground" role="status">{loading ? copy.loading_channels : failed ? copy.list_failed : options.length === 0 ? copy.no_channels : null}</p>
  </div>
}
